import { combineReducers } from "redux";
import todos from "./toDo";

const rootReducer = combineReducers({
  todos,
});

export default rootReducer;
